module.exports = __webpack_public_path__ + "images/emoji/office.86261365d2967c46e3d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/office.png
// module id = 833W
// module chunks = 1